import WorkItem from './WorkItem';

export default WorkItem;
